import { useCallback, useRef, useState } from 'react';

/**
 * Trava o disparo repetido de uma operação de salvar/atualizar e simula o
 * percentual exibido no overlay `TelaBloqueioSalvando` enquanto o servidor
 * não responde.
 */
export const useBloqueioSalvamento = () => {
  const isSavingRef = useRef(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [progress, setProgress] = useState(0);

  const pararIntervalo = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  /** Chame no início do handler de salvar. Retorna false se já há um salvamento em andamento. */
  const iniciar = useCallback((): boolean => {
    if (isSavingRef.current) return false;

    isSavingRef.current = true;
    setIsSaving(true);
    setProgress(0);

    intervalRef.current = setInterval(() => {
      setProgress(prev => (prev >= 90 ? prev : prev + 10));
    }, 400);

    return true;
  }, []);

  /** Chame quando o servidor responder com sucesso. */
  const concluir = useCallback((delayMs = 600) => {
    pararIntervalo();
    setProgress(100);
    setTimeout(() => {
      isSavingRef.current = false;
      setIsSaving(false);
      setProgress(0);
    }, delayMs);
  }, []);

  /** Chame quando o servidor responder com erro ou a validação falhar. */
  const cancelar = useCallback(() => {
    pararIntervalo();
    isSavingRef.current = false;
    setIsSaving(false);
    setProgress(0);
  }, []);

  return { isSaving, progress, iniciar, concluir, cancelar };
};
